import { InputType } from 'config'

export const defaultInputs = (): Record<string, InputType> => {
  const inputs: Record<string, InputType> = {}
  inputs['divider'] = {
    inputType: 'custom',
    title: '',
    visible: true,
  }
  inputs['adminEmailDns'] = {
    inputType: 'text',
    title: 'Email DNS of Administrator',
    required: false,
    visible: true,
  }
  inputs['defaultReceiver'] = {
    inputType: 'text',
    title: 'Default Email which receive emails',
    type: 'email',
    required: false,
    visible: true,
  }
  inputs['loanAddressCopy'] = {
    inputType: 'select',
    title: "Copy the loan's email address on emails sent from a loan",
    options: { none: 'Do not copy', cc: 'Cc', bcc: 'Bcc' },
    hasDefaultOption: false,
    required: false,
    visible: true,
  }
  return inputs
}
